




































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { unimedNegativeMarginProcedures } from '@/utils/unimed-negative-margin-procedures'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'
import { backofficeRoute } from '@/utils/common'

@Component
export default class ComponenteBackofficeProtocolo extends Vue {
  @Prop({ default: false }) flat: boolean

  get surgeryProtocolStatus(): undefined | 'CriouSolicitacaoAPartirDoProtocolo' | 'AceitouSugestaoDaFinxDeSeguirOProtocolo' | 'RecusouSugestaoDaFinxDeSeguirOProtocolo' {
    return this.backofficeGlobalStore.solicitacao.protocoloDeCirurgia && this.backofficeGlobalStore.solicitacao.protocoloDeCirurgia.status
  }

  get backofficeArea(): string | null | undefined {
    return backofficeRoute()
  }

  get backofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get canShowProtocolArea() {
    return this.canShowCirurgicalProtocol || this.canShowSantaLuciaProtocolWithUnimedNegativeMargin || this.canShowNaoSegueOProtocolo
  }

  get canShowCirurgicalProtocol() {
    return this.backofficeGlobalStore.solicitacao.protocoloDeCirurgia
  }

  get canShowSegueOProtocolo() {
    return this.backofficeGlobalStore.solicitacao.protocoloDeCirurgia
      && this.backofficeGlobalStore.solicitacao.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.segueOProtocolo
  }

  get canShowNaoSegueOProtocolo() {
    return this.backofficeGlobalStore.solicitacao.protocoloDeCirurgia
      && this.backofficeGlobalStore.solicitacao.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo
  }

  get canShowSantaLuciaProtocolWithUnimedNegativeMargin() {
    // Check hospital in solicitation is not SANTA LUCIA
    const hospitalId = 'A24FB459-87A9-4189-9211-132BEE0E3198' // 'HOSPITAL E MATERNIDADE SANTA LUCIA' GUID
    if (this.backofficeGlobalStore.solicitacao.hospitalId.toUpperCase() !== hospitalId) {
      return false
    }

    // Check the medical insurance is not unimed
    const regex = new RegExp('unimed', 'gi')
    if (!regex.test(this.backofficeGlobalStore.solicitacao.convenioNome!)) {
      return false
    }

    // Check any procedure in solicitation not exists in unimed list
    const additionalProcedures = this.backofficeGlobalStore.solicitacao.procedimentosAssociados || []
    const solicitationProcedures = [
      this.backofficeGlobalStore.solicitacao.procedimento,
      ...additionalProcedures,
    ]

    let existsProcedureFromSolicitationInUnimedList = false
    solicitationProcedures.every((elem) => {
      const code = (elem && elem.codigo) || ''
      if (unimedNegativeMarginProcedures.includes(code)) {
        existsProcedureFromSolicitationInUnimedList = true
        return false
      }
      return true
    })

    if (!existsProcedureFromSolicitationInUnimedList) {
      return false
    }

    return true
  }

  get surgeryProtocolStatusLabel() {
    if (this.surgeryProtocolStatus) {
      const surgeryProtocolStatusLabelTypes = {
        CriouSolicitacaoAPartirDoProtocolo: 'Médico criou solicitação a partir do protocolo',
        AceitouSugestaoDaFinxDeSeguirOProtocolo: 'Médico aceitou o protocolo sugerido pela Operadora',
        RecusouSugestaoDaFinxDeSeguirOProtocolo: 'Médico recusou o protocolo sugerido pela Operadora',
      }

      return surgeryProtocolStatusLabelTypes[this.surgeryProtocolStatus]
    }

    return ''
  }
}
